import React, { useState } from "react";
import { Link } from "react-router-dom";
// import IconSocalFurs from './SocalDate.jpg'
import IconSocalFurs from './Socalfurs.jpg'
import './AboutPage.css'

export default function ContactPage() {


  return (

       <div className = "about-us-main-container">
                  {/* <img className="homepage-main-icon" src={AfcImage} alt="Socalfurs.com" /> */}

            <div className = "about-us-container-1">
                      <header className = "about-us-header">Contact Us: Socalfurs</header>
                      <p className = "about-us-p">
                       For Any Questions, Comments, or Concerns? 
                       Please E-mail our team! <a href = "mailto:Admin@SoCalFurs.com">Admin@SoCalFurs.com</a> Or DM <a href="https://t.me/ag_shep ">@AG_Shep</a> on Telegram.

                        </p>
                      <p>  To Report Website Errors, E-mail Our <a href = "mailto:Webmaster@SoCalFurs.com">Webmaster@SoCalFurs.com</a></p>

                      
            </div>

            <div className = "about-us-space"></div>
            <div className = "about-us-image-container">
              <img className = "about-us-img" src = {IconSocalFurs}></img>
            </div>
    
                      
        </div>

         
  );
}
